import {ApiStats} from '../types/api'

// 모든 API 요청의 단일 base URL. 기존에 분리돼 있던 도메인/버전별 상수는 모두 여기로 통합됨.
// 프로덕션 빌드라도 접속 호스트가 admin-dev.leagueoftraders.io이면 dev API를 바라보게 해,
// 동일한 프로덕션 번들을 prod/dev 어드민 도메인에서 함께 쓸 수 있게 한다.
const resolveApiUrl = (): string => {
    if (process.env.NODE_ENV !== 'production') {
        return 'https://api.lot.localhost/v3'
    }
    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    if (hostname === 'admin-dev.leagueoftraders.io') {
        return 'https://dev.leagueoftraders.io/v3'
    }
    return 'https://api.leagueoftraders.io/v3'
}

export const API_URL = resolveApiUrl()

export const apiGet = async (domain: string, url: string, body?: any, headerOverrides?: Partial<Headers>) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'GET',
            // 요청 단위 헤더 오버라이드 (예: language 강제) — 전달 시 기본 헤더에 병합
            headers: {...getHeaders(), ...(headerOverrides || {})},
        })

        const res = await response.json()
        if (res.prices !== undefined) {
            return {data: res.prices, status: 200, error: ''}
        }
        if (res.status === ApiStats.Success || res.code === ApiStats.Success) {
            let pageinfo = res.paging_info ? res.paging_info : res.page_info
            return {data: res.data, status: res.status, pageInfo: pageinfo, isManager: res?.isManager}
        }
        return {
            data: undefined,
            status: res.status,
            error: res.error,
            Message: res?.Message,
            code: res?.code,
            isManager: res?.isManager,
        }
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const dataGet = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: getHeaders(),
        })

        const res = await response.json()
        return {data: res, status: 200}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const apiGetV1 = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: getHeaders(),
        })
        const res = await response.json()
        if (res) {
            return {data: res, status: ApiStats.Success}
        }
        return {data: undefined, status: res.status, error: res.error}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const apiPost = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(body),
        })
        const res = await response.json()
        if (res.status === ApiStats.Success || res.code === ApiStats.Success || res.success) {
            return {data: res.data, status: res.status}
        }
        return {data: undefined, status: res.status, error: res.error}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const apiPut = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(body),
        })

        const res = await response.json()
        if (res.status === ApiStats.Success || res.code === ApiStats.Success) {
            return {data: res.data, status: res.status}
        }
        return {data: undefined, status: res.status, error: res.error}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const apiPatch = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'PATCH',
            headers: getHeaders(),
            body: JSON.stringify(body),
        })

        const res = await response.json()
        if (res.status === ApiStats.Success || res.code === ApiStats.Success) {
            return {data: res.data, status: res.status}
        }
        return {data: undefined, status: res.status, error: res.error}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

export const apiDelete = async (domain: string, url: string, body?: any) => {
    try {
        const endpoint = `${domain}/${url}`
        const response = await fetch(endpoint, {
            method: 'DELETE',
            headers: getHeaders(),
            body: JSON.stringify(body),
        })

        const res = await response.json()
        if (res.status === ApiStats.Success) {
            return {data: res.data, status: res.status}
        }
        return {data: undefined, status: res.status, error: res.error}
    } catch (e: any) {
        return {data: undefined, status: -1, error: e.toString()}
    }
}

type Headers = {
    Accept: string
    'Content-Type': string
    'Access-Token': string
    source: string
    language: string
}

const getHeaders = (): Headers => {
    const lang = localStorage?.getItem('lang') === 'en' ? 'en' : 'ko'
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Token': localStorage.getItem('wiz-admin-userToken')
            ? (localStorage.getItem('wiz-admin-userToken') as string)
            : '',
        source: 'web',
        language: lang,
    }
}
